export default __webpack_public_path__ + "static/collection-4-0734e249f78a50ccb23201d834adced8.webp";